import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import enCaApprovalHistory from "../locales/en-ca/approvalHistory.json"
import enCaCommon from "../locales/en-ca/common.json"
import enCaDashboard from "../locales/en-ca/dashboard.json"
import enCaFleetImpersonation from "../locales/en-ca/fleetImpersonation.json"
import enCaFleets from "../locales/en-ca/fleets.json"
import enCaFMCDashboard from "../locales/en-ca/fmcDashboard.json"
import enCaFMCUsers from "../locales/en-ca/fmcUsers.json"
import enCaMaintenanceHistory from "../locales/en-ca/maintenanceHistory.json"
import enCaMembershipCard from "../locales/en-ca/membershipCard.json"
import enCaNotificationsReminder from "../locales/en-ca/notificationsReminder"
import enCaPayment from "../locales/en-ca/payment.json"
import enCaPaymentActivity from "../locales/en-ca/paymentActivity.json"
import enRecommendedServiceModal from "../locales/en-ca/recommendedServiceModal"
import enCaSchedule from "../locales/en-ca/schedule.json"
import enCaScheduleRequest from "../locales/en-ca/scheduleRequest.json"
import enCaServices from "../locales/en-ca/services.json"
import enCaSettings from "../locales/en-ca/settings.json"
import enCaShopOrders from "../locales/en-ca/shopOrders.json"
import enCaShops from "../locales/en-ca/shops.json"
import enCaSiteHeader from "../locales/en-ca/siteHeader.json"
import enCaVehicle from "../locales/en-ca/vehicle.json"
import enCaVehicleIndex from "../locales/en-ca/vehicleIndex.json"
import enApprovalHistory from "../locales/en/approvalHistory.json"
import enCommon from "../locales/en/common.json"
import enDashboard from "../locales/en/dashboard.json"
import enFleetImpersonation from "../locales/en/fleetImpersonation.json"
import enFleets from "../locales/en/fleets.json"
import enFMCDashboard from "../locales/en/fmcDashboard.json"
import enFMCUsers from "../locales/en/fmcUsers.json"
import enGeotab from "../locales/en/geotab.json"
import enMaintenanceHistory from "../locales/en/maintenanceHistory.json"
import enMaintenanceSchedule from "../locales/en/maintenanceSchedule.json"
import enMembershipCard from "../locales/en/membershipCard.json"
import enMembershipFleetCard from "../locales/en/membershipFleetCard.json"
import enNotificationsReminder from "../locales/en/notificationsReminder.json"
import enPayment from "../locales/en/payment.json"
import enPaymentActivity from "../locales/en/paymentActivity.json"
import enSchedule from "../locales/en/schedule.json"
import enScheduleRequest from "../locales/en/scheduleRequest.json"
import enServices from "../locales/en/services.json"
import enSettings from "../locales/en/settings.json"
import enShopOrders from "../locales/en/shopOrders.json"
import enShops from "../locales/en/shops.json"
import enSiteHeader from "../locales/en/siteHeader.json"
import enVehicle from "../locales/en/vehicle.json"
import enVehicleIndex from "../locales/en/vehicleIndex.json"
import frCaApprovalHistory from "../locales/fr-ca/approvalHistory.json"
import frCaCommon from "../locales/fr-ca/common.json"
import frCaDashboard from "../locales/fr-ca/dashboard.json"
import frCaFleetImpersonation from "../locales/fr-ca/fleetImpersonation.json"
import frCaFleets from "../locales/fr-ca/fleets.json"
import frCaFMCDashboard from "../locales/fr-ca/fmcDashboard.json"
import frCaFMCUsers from "../locales/fr-ca/fmcUsers.json"
import frCaGeotab from "../locales/fr-ca/geotab.json"
import frCaMaintenanceHistory from "../locales/fr-ca/maintenanceHistory.json"
import frMaintenanceSchedule from "../locales/fr-ca/maintenanceSchedule.json"
import frCaMembershipCard from "../locales/fr-ca/membershipCard.json"
import frMembershipFleetCard from "../locales/fr-ca/membershipFleetCard.json"
import frCaNotificationsReminder from "../locales/fr-ca/notificationsReminder"
import frCaPayment from "../locales/fr-ca/payment.json"
import frCaPaymentActivity from "../locales/fr-ca/paymentActivity.json"
import frRecommendedServiceModal from "../locales/fr-ca/recommendedServiceModal"
import frCaSchedule from "../locales/fr-ca/schedule.json"
import frCaScheduleRequest from "../locales/fr-ca/scheduleRequest.json"
import frCaServices from "../locales/fr-ca/services.json"
import frCaSettings from "../locales/fr-ca/settings.json"
import frCaShopOrders from "../locales/fr-ca/shopOrders.json"
import frCaShops from "../locales/fr-ca/shops.json"
import frCaSiteHeader from "../locales/fr-ca/siteHeader.json"
import frCaVehicle from "../locales/fr-ca/vehicle.json"
import frCaVehicleIndex from "../locales/fr-ca/vehicleIndex.json"
import enMaintenaceHistoryDetails from "../locales/en-ca/maintenaceHistoryDetails"
import frMaintenaceHistoryDetails from "../locales/fr-ca/maintenaceHistoryDetails"
import enMagicLink from "../locales/en/magicLink.json"
import enACHPayment from "../locales/en/achPayment.json"
import frACHPayment from "../locales/fr-ca/achPayment.json"
import enReports from "../locales/en/reports.json"
import frReports from "../locales/fr-ca/reports.json"
import enSfoTrack from "../locales/en/sfoTrack.json"
import frSfoTrack from "../locales/fr-ca/sfoTrack.json"
import enTopTiers from "../locales/en/topTires.json"
import frTopTiers from "../locales/fr-ca/topTires.json"
import enTiersFilter from "../locales/en/tireFilters.json"
import frTiersFilter from "../locales/fr-ca/tireFilters.json"
import enTireDetails from "../locales/en/tireDetails.json"
import frTireDetails from "../locales/fr-ca/tireDetails.json"

import { locales } from "caradvise_shared_components"

import {
  APPROVALS_FORM,
  APPROVALS_FORM_CANCEL,
  APPROVALS_FORM_FIELD,
  APPROVALS_FORM_FIELDS,
  APPROVALS_FORM_HEADER,
  APPROVALS_FORM_NOTES,
  APPROVALS_FORM_PAYMENT_METHOD,
  APPROVALS_FORM_SUBMIT,
  APPROVALS_FORM_TOTALS,
  APPROVALS_INFO_MODEL,
  APPROVAL_EMPTY_STATE,
  APPROVAL_HISTORY,
  APPROVAL_TOGGLE_BUTTON,
  COMMON,
  DASHBOARD,
  FLEETS,
  FLEET_IMPERSONATION,
  FMC_DASHBOARD,
  FMC_USERS,
  GEOTAB,
  MAINTENANCE_HISTORY,
  MEMBERSHIP_CARD,
  NOTIFICATIONS_REMINDER,
  NO_INFORMATION,
  ORDER_SERVICE_COMMENT,
  ORDER_SERVICE_MODAL_INFO,
  PAYMENT,
  PRICE_EXPLANATION,
  PRICE_INFO_DISPLAY,
  PRIVACY_POLICY_AND_TERMS,
  SCHEDULE_REQUEST,
  SERVICES,
  SETTINGS,
  SHOPS,
  SHOP_ORDERS,
  SITE_HEADER,
  VEHICLE,
  VEHICLE_INDEX
} from "../constants/namespaces"
import { EN_LOCALE } from "../constants/users"
import reports from "../actions/reducers/reports"

const {
  enApprovalsEmptyState,
  enApprovalsForm,
  enApprovalsFormHeader,
  enApprovalsFormFields,
  enApprovalsFormField,
  enApprovalsInfoModal,
  enApprovalsFormNotes,
  enApprovalsFormTotals,
  enApprovalsFormPaymentMethod,
  enApprovalsFormCancel,
  enApprovalsFormSubmit,
  enPriceInfoDisplay,
  enNoInformation,
  enOrderServiceModalInfo,
  enPriceExplanation,
  enPrivacyPolicyAndTerms,
  enApprovalToggleButton,
  enOrderServiceComment,
  enApprovalsFormVanity
} = locales.en
const {
  frApprovalsEmptyState,
  frApprovalsForm,
  frApprovalsFormHeader,
  frApprovalsFormFields,
  frApprovalsFormField,
  frApprovalsInfoModal,
  frApprovalsFormNotes,
  frApprovalsFormTotals,
  frApprovalsFormPaymentMethod,
  frApprovalsFormCancel,
  frApprovalsFormSubmit,
  frPriceInfoDisplay,
  frNoInformation,
  frOrderServiceModalInfo,
  frPriceExplanation,
  frPrivacyPolicyAndTerms,
  frApprovalToggleButton,
  frOrderServiceComment,
  frApprovalsFormVanity
} = locales.fr

// Even though this product doesn't currently support multiple languages, this library is needed
// to be able to pass the `t` function from i18next to caradvise_shared_components
i18n.use(initReactI18next).init({
  lng: EN_LOCALE,
  ns: [
    COMMON,
    FMC_DASHBOARD,
    SITE_HEADER,
    DASHBOARD,
    FMC_USERS,
    FLEET_IMPERSONATION,
    VEHICLE_INDEX,
    SERVICES,
    SHOPS,
    SETTINGS,
    MAINTENANCE_HISTORY,
    PAYMENT,
    VEHICLE,
    SCHEDULE_REQUEST,
    SHOP_ORDERS,
    APPROVAL_EMPTY_STATE,
    APPROVALS_FORM,
    APPROVALS_FORM_HEADER,
    APPROVALS_FORM_FIELDS,
    APPROVALS_FORM_FIELD,
    APPROVALS_INFO_MODEL,
    APPROVALS_FORM_NOTES,
    APPROVALS_FORM_TOTALS,
    APPROVALS_FORM_PAYMENT_METHOD,
    APPROVALS_FORM_CANCEL,
    APPROVALS_FORM_SUBMIT,
    PRICE_INFO_DISPLAY,
    NO_INFORMATION,
    ORDER_SERVICE_MODAL_INFO,
    PRICE_EXPLANATION,
    PRIVACY_POLICY_AND_TERMS,
    APPROVAL_TOGGLE_BUTTON,
    ORDER_SERVICE_COMMENT,
    FLEETS,
    MEMBERSHIP_CARD,
    APPROVAL_HISTORY,
    GEOTAB,
    NOTIFICATIONS_REMINDER
  ],
  defaultNS: COMMON,
  resources: {
    en: {
      common: enCommon,
      fmcDashboard: enFMCDashboard,
      siteHeader: enSiteHeader,
      dashboard: enDashboard,
      schedule: enSchedule,
      fmcUsers: enFMCUsers,
      fleetImpersonation: enFleetImpersonation,
      vehicleIndex: enVehicleIndex,
      services: enServices,
      shops: enShops,
      settings: enSettings,
      maintenanceHistory: enMaintenanceHistory,
      payment: enPayment,
      paymentActivity: enPaymentActivity,
      vehicle: enVehicle,
      scheduleRequest: enScheduleRequest,
      shopOrders: enShopOrders,
      approvalsEmptyState: enApprovalsEmptyState,
      approvalsForm: enApprovalsForm,
      approvalsFormHeader: enApprovalsFormHeader,
      approvalsFormFields: enApprovalsFormFields,
      approvalsFormField: enApprovalsFormField,
      approvalsInfoModal: enApprovalsInfoModal,
      approvalsFormNotes: enApprovalsFormNotes,
      approvalsFormTotals: enApprovalsFormTotals,
      approvalsFormPaymentMethod: enApprovalsFormPaymentMethod,
      approvalsFormCancel: enApprovalsFormCancel,
      approvalsFormSubmit: enApprovalsFormSubmit,
      approvalToggleButton: enApprovalToggleButton,
      approvalsFormVanity: enApprovalsFormVanity,
      priceInfoDisplay: enPriceInfoDisplay,
      noInformation: enNoInformation,
      orderServiceComment: enOrderServiceComment,
      orderServiceModalInfo: enOrderServiceModalInfo,
      priceExplanation: enPriceExplanation,
      privacyPolicyAndTerms: enPrivacyPolicyAndTerms,
      fleets: enFleets,
      membershipCard: enMembershipCard,
      approvalHistory: enApprovalHistory,
      geotab: enGeotab,
      maintenanceSchedule: enMaintenanceSchedule,
      notificationsReminder: enNotificationsReminder,
      recommendedServiceModal: enRecommendedServiceModal,
      maintenaceHistoryDetails: enMaintenaceHistoryDetails,
      membershipFleetCard: enMembershipFleetCard,
      magicLink: enMagicLink,
      achPayment: enACHPayment,
      reports: enReports,
      sfoTrack: enSfoTrack,
      topTiers: enTopTiers,
      tiersFilter: enTiersFilter,
      tierDetails: enTireDetails
    },
    "fr-CA": {
      common: frCaCommon,
      fmcDashboard: frCaFMCDashboard,
      siteHeader: frCaSiteHeader,
      dashboard: frCaDashboard,
      schedule: frCaSchedule,
      fmcUsers: frCaFMCUsers,
      fleetImpersonation: frCaFleetImpersonation,
      vehicleIndex: frCaVehicleIndex,
      services: frCaServices,
      shops: frCaShops,
      settings: frCaSettings,
      maintenanceHistory: frCaMaintenanceHistory,
      payment: frCaPayment,
      PaymentActivity: frCaPaymentActivity,
      vehicle: frCaVehicle,
      scheduleRequest: frCaScheduleRequest,
      shopOrders: frCaShopOrders,
      approvalsEmptyState: frApprovalsEmptyState,
      approvalsForm: frApprovalsForm,
      approvalsFormHeader: frApprovalsFormHeader,
      approvalsFormFields: frApprovalsFormFields,
      approvalsFormField: frApprovalsFormField,
      approvalsInfoModal: frApprovalsInfoModal,
      approvalsFormNotes: frApprovalsFormNotes,
      approvalsFormTotals: frApprovalsFormTotals,
      approvalsFormPaymentMethod: frApprovalsFormPaymentMethod,
      approvalsFormCancel: frApprovalsFormCancel,
      approvalsFormSubmit: frApprovalsFormSubmit,
      approvalToggleButton: frApprovalToggleButton,
      approvalsFormVanity: frApprovalsFormVanity,
      priceInfoDisplay: frPriceInfoDisplay,
      noInformation: frNoInformation,
      orderServiceComment: frOrderServiceComment,
      orderServiceModalInfo: frOrderServiceModalInfo,
      priceExplanation: frPriceExplanation,
      privacyPolicyAndTerms: frPrivacyPolicyAndTerms,
      fleets: frCaFleets,
      membershipCard: frCaMembershipCard,
      approvalHistory: frCaApprovalHistory,
      geotab: frCaGeotab,
      maintenanceSchedule: frMaintenanceSchedule,
      notificationsReminder: frCaNotificationsReminder,
      recommendedServiceModal: frRecommendedServiceModal,
      maintenaceHistoryDetails: frMaintenaceHistoryDetails,
      membershipFleetCard: frMembershipFleetCard,
      achPayment: frACHPayment,
      reports: frReports,
      sfoTrack: frSfoTrack,
      topTiers: frTopTiers,
      tiersFilter: frTiersFilter,
      tierDetails: frTireDetails
    },
    "en-CA": {
      common: enCaCommon,
      fmcDashboard: enCaFMCDashboard,
      siteHeader: enCaSiteHeader,
      dashboard: enCaDashboard,
      schedule: enCaSchedule,
      fmcUsers: enCaFMCUsers,
      fleetImpersonation: enCaFleetImpersonation,
      vehicleIndex: enCaVehicleIndex,
      services: enCaServices,
      shops: enCaShops,
      settings: enCaSettings,
      maintenanceHistory: enCaMaintenanceHistory,
      payment: enCaPayment,
      PaymentActivity: enCaPaymentActivity,
      vehicle: enCaVehicle,
      scheduleRequest: enCaScheduleRequest,
      shopOrders: enCaShopOrders,
      approvalsEmptyState: enApprovalsEmptyState,
      approvalsForm: enApprovalsForm,
      approvalsFormHeader: enApprovalsFormHeader,
      approvalsFormFields: enApprovalsFormFields,
      approvalsFormField: enApprovalsFormField,
      approvalsInfoModal: enApprovalsInfoModal,
      approvalsFormNotes: enApprovalsFormNotes,
      approvalsFormTotals: enApprovalsFormTotals,
      approvalsFormPaymentMethod: enApprovalsFormPaymentMethod,
      approvalsFormCancel: enApprovalsFormCancel,
      approvalsFormSubmit: enApprovalsFormSubmit,
      approvalsFormVanity: enApprovalsFormVanity,
      approvalToggleButton: enApprovalToggleButton,
      priceInfoDisplay: enPriceInfoDisplay,
      noInformation: enNoInformation,
      orderServiceComment: enOrderServiceComment,
      orderServiceModalInfo: enOrderServiceModalInfo,
      priceExplanation: enPriceExplanation,
      privacyPolicyAndTerms: enPrivacyPolicyAndTerms,
      fleets: enCaFleets,
      membershipCard: enCaMembershipCard,
      approvalHistory: enCaApprovalHistory,
      maintenanceSchedule: enMaintenanceSchedule,
      notificationsReminder: enCaNotificationsReminder,
      recommendedServiceModal: enRecommendedServiceModal,
      maintenaceHistoryDetails: enMaintenaceHistoryDetails,
      magicLink: enMagicLink,
      achPayment: enACHPayment,
      reports: enReports
    }
  },
  fallbackLng: EN_LOCALE,
  interpolation: {
    escapeValue: false
  }
})

export default i18n
